import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manager';

const list = (systemSource, merchantId, branchId, type) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/depositSettings`),
		{
			branchId,
			type,
		}
	);
};

const find = (systemSource, merchantId, branchId, id) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/depositSettings/${id}`
		),
		{
			branchId,
		}
	);
};

const create = (
	systemSource,
	merchantId,
	branchId,
	min,
	value,
	type,
	depositPayType,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/depositSettings`),
		{
			branchId,
			depositPayType,
			type,
			min,
			value,
			operateBy,
		}
	);
};

const update = (
	systemSource,
	merchantId,
	branchId,
	id,
	min,
	value,
	type,
	depositPayType,
	operateBy
) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/depositSettings/${id}`
		),
		{
			branchId,
			depositPayType,
			type,
			min,
			value,
			operateBy,
			stopFlag: false,
		}
	);
};

const remove = (systemSource, merchantId, branchId, id, operateBy) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/depositSettings/${id}`
		),
		{
			branchId,
			operateBy,
		}
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
